import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmDocumentType } from '../interfaces/IKnmDocumentType';

export async function fetchKnmDocumentTypes(): Promise<IKnmDocumentType[]> {
  return apiGet<IKnmDocumentType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-document-types`);
}
